























































































import { Component, Prop } from 'vue-property-decorator';
import Base from '../../Base';
import WSwitch from '@/components/WSwitch.vue';
import { ConferenceTypeForm } from '@/models/OperatorForm';

@Component({
	components: { WSwitch }
})
export default class ConferenceType extends Base {
	@Prop() form!: ConferenceTypeForm;
	@Prop() validation!: any;

	open = true;

	toggleOpen(): void {
		this.open = !this.open;
	}
}
